import React, { Component } from 'react';

class Packages extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    const { packages, selectedChannels } = this.props;
    const url_string = window.location.href;
    const url = new URL(url_string);
    const color = url.searchParams.get("color");

    let channelButtonTitleStyle;

    channelButtonTitleStyle = {
      backgroundColor: '#1e1e1e',
      borderColor: '#595959',
    }

    if (color === 'grey') {
      channelButtonTitleStyle = {
        backgroundColor: '#1e1e1e',
        borderColor: '#595959',
      }
    } else if (color === 'red') {
      channelButtonTitleStyle = {
        backgroundColor: '#dc3545',
        borderColor: '#dc3545',
      }
    }

    const renderBundlePrice = (price) => {
      console.log('PRICE', price)
      if (price === 0) {
        return (
          <span>
            <span className="period price-varies">Price varies based on packages chosen</span>
          </span>
        )
      }
      return (
        <span>
          <span className="cost">{(price / 100).toFixed(2)}</span>
          <span className="period">/month</span>
        </span>
      )
    }

    return (
      <div className="row justify-content-center">
        {(packages.length < 1 && selectedChannels.length > 0 && !this.props.loading) ? (
          <h1 className="mt-5">No Results</h1>
        ) : (
            packages.map((item, i) => (
              <div key={i} className="col-lg-12 mb-5">
                <div className="card mb-5 mb-lg-0">
                  <div className="card-body">
                    <div className="card-logo">
                      <img src={item.logo} alt="" />
                      <h5 className="card-title text-muted text-uppercase">{item.type === 'package' ? item.name : item.title}</h5>
                    </div>

                    <ul className="stream-count">
                      <li><i className="fal fa-tv"></i> {item.type === 'package' ? item.number_of_streams : item.no_of_streams} {((item.number_of_streams || item.no_of_streams) > 1) ? 'Streams' : 'Stream'}</li>
                    </ul>
                    <div className="devices">
                      <strong><i className="fal fa-mobile-alt"></i> Devices</strong>
                      <ul>
                        {
                          (item.type !== 'package' ? JSON.parse(item.devices || '[]') : item.devices).map(d => <li key={i}>{d}</li>)
                        }
                      </ul>
                    </div>
                    <div className="card-price text-center">{renderBundlePrice(item.price)}</div>

                    <a href={item.bundle_url} target="_blank" className="btn btn-block btn-primary text-uppercase" style={channelButtonTitleStyle}>Get Now</a>
                  </div>

                  {(item.notes) ? (
                    <div className="notes">
                      <p>{item.notes}</p>
                    </div>
                  ) : (null)}
                </div>
              </div>
            ))
          )}
      </div>
    )
  }
}
export default Packages;



// WEBPACK FOOTER //
// ./src/components/Picker/Packages.js